<template>
  <li class="context-menu-item">
    <slot />
  </li>
</template>

<script>
export default {};
</script>

<style lang="css" scoped>
.context-menu-item {
  display: block;
  position: relative;
  padding: 2px 2px;
  background: #000;
  background: var(--offWhite);
  border-bottom: 1px solid var(--grey-lighter);
  color: #000;
  text-decoration: none;
  font-size: 13px;
  width: 100%;
  text-align: left;
  cursor: pointer;
  padding: 8px;
  transition: all 300ms ease;
}

.context-menu-item:hover,
.context-menu-item:focus {
  background: var(--grey-lightest);
  color: #000;
  outline: none;
}
</style>
